import { GeneralService } from './general.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class TonHrLnService {

    constructor(protected generalService: GeneralService) {
    }

    public async calcToneladasHorasLanes(pSiteRecebimento: string, pTempoDescarga: number, pLinhaDescarga: string, pPesoLiquido: number): Promise<number> {
        let lanes: number = 0;
        let resultado: number = 0;
        if (!!pSiteRecebimento && !!pTempoDescarga && !!pLinhaDescarga && !!pPesoLiquido) {
            pPesoLiquido = this.generalService.CalcTon(pPesoLiquido);
            lanes = await this.lanesBySiteByLinha(pSiteRecebimento, pLinhaDescarga);
            if (!!lanes && !!pTempoDescarga) {
                if (lanes > 0 && Number(pTempoDescarga) > 0) {
                    resultado = pPesoLiquido / lanes / Number(pTempoDescarga);
                }
            }
        }
        return resultado;
    }

    private async lanesBySiteByLinha(pSiteRecebimento: string, pLinhaDescarga: string): Promise<number> {

        let valor: number = 0;

        if (!!pSiteRecebimento && !!pLinhaDescarga) {
            //console.log(pSiteRecebimento)
            switch (pSiteRecebimento.toUpperCase()) {
                case 'SHG':
                    valor = await this.getResultFromSHG(pLinhaDescarga.toUpperCase());
                    break;
                case 'UDI':
                    valor = await this.getResultFromUDI(pLinhaDescarga.toUpperCase());
                    break;
                case 'PTU':
                    valor = await this.getResultFromPTU(pLinhaDescarga.toUpperCase());
                    break;
                case 'CVE':
                    valor = await this.getResultFromCVE(pLinhaDescarga.toUpperCase());
                    break;
                case 'ITA':
                    valor = await this.getResultFromITA(pLinhaDescarga.toUpperCase());
                    break;
                case 'CDR':
                    valor = await this.getResultFromCDR(pLinhaDescarga.toUpperCase());
                    break;
                case 'PTU-BÁSICA':
                    valor = await this.getResultFromPTUBASICA(pLinhaDescarga.toUpperCase());
                    break;
                case 'PTU-BASICA':
                    valor = await this.getResultFromPTUBASICA(pLinhaDescarga.toUpperCase());
                    break;
            }
        }
        return valor;
    }

    private getResultFromSHG(pLinhaDescarga: string): number {
        const map = new Map<string, number>();
        map.set('1', 64);
        map.set('2', 56);
        map.set('3', null);
        map.set('4', null);
        map.set('MANUAL', null);
        return map.get(pLinhaDescarga);
    }

    private getResultFromUDI(pLinhaDescarga: string): number {
        const map = new Map<string, number>();
        map.set('1', 72);
        map.set('2', 72);
        map.set('3', 64);
        map.set('4', 72);
        map.set('MANUAL', null);
        return map.get(pLinhaDescarga);
    }

    private getResultFromPTU(pLinhaDescarga: string): number {
        const map = new Map<string, number>();
        map.set('1', 56);
        map.set('2', 64);
        map.set('3', 96);
        map.set('4', 64);
        map.set('MANUAL', null);
        return map.get(pLinhaDescarga);
    }

    private getResultFromCVE(pLinhaDescarga: string): number {
        const map = new Map<string, number>();
        map.set('1', 96);
        map.set('2', 108);
        map.set('3', null);
        map.set('4', null);
        map.set('MANUAL', null);
        return map.get(pLinhaDescarga);
    }

    private getResultFromITA(pLinhaDescarga: string): number {
        const map = new Map<string, number>();
        map.set('1', 80);
        map.set('2', 80);
        map.set('3', null);
        map.set('4', null);
        map.set('MANUAL', null);
        return map.get(pLinhaDescarga);
    }

    private getResultFromCDR(pLinhaDescarga: string): number {
        const map = new Map<string, number>();
        map.set('1', 32);
        map.set('2', 16);
        map.set('3', null);
        map.set('4', null);
        map.set('MANUAL', null);
        return map.get(pLinhaDescarga);
    }

    private getResultFromPTUBASICA(pLinhaDescarga: string): number {
        const map = new Map<string, number>();
        map.set('1', 16);
        map.set('2', 16);
        map.set('3', null);
        map.set('4', null);
        map.set('MANUAL', null);
        return map.get(pLinhaDescarga);
    }
}
